<template>
	<div class="stage stage--simonsays" :style="{ 'background-image': backgroundImage }">

		<div class="content-container">

			<div class="header__container">
				<div class="header" style="position: relative">
					{{roundData.header}}
				</div>
			</div>

			<div class="btn__explanation" @click="showExplanationPopup">
				<i class="fa fa-question"></i>
			</div>
			
			<div class="card card-simonsays">
				<div class="timer">	
					<div class="timer__icon">
						<i class="fa fa-clock-o" aria-hidden="true"></i>
					</div>
					<div class="timer__time">
						{{displayTime}}
					</div>
				</div>

				<div class="text" v-html="questionData.questiontext" />

				<div class="simonsays__answer__holder">
					<div v-if="questionData != null" class="simonsays__answer__container">
						<div v-for="answer,index in questionData.answers" class="simonsays__answer" :class="{'selected' : answers.includes(index)}" @click="()=>{onAnswer(index)}">
							<img :src="baseUrl + answer.visual"/>
						</div>
					</div>
				</div>
				<div class="simonsays__info" @click="showOverlay">
					<i class="fa fa-play"></i>
					<!-- <img src=""/> -->
				</div>

				<div class="simonsays__legenda">
					<div v-for="answer,index in questionData.answers" class="simonsays__legenda__item">
						{{answer.label}}
					</div>
				</div>
			</div>

			<Overlay
				v-if="question == true"
				:header="questionData.header"
				:text="questionData.questiontext"
				:visual="baseUrl + questionData.visual"
				:on-click="hideOverlay"
			/>

			<ExplanationPopup 
			v-if="explanationPopupActive == true" 
			:additionalHTML="additionalHTML"
			:on-click="hideExplanationPopup"/>

		</div>

	</div>
</template>

<script>
	import Score from '../../Score.vue';
	import Overlay from './Overlay.vue';
	import { url} from '../../../const/base';
	import { mapGetters , mapActions } from 'vuex';
	import ExplanationPopup from '../ExplanationPopup.vue';

	export default {

		components:{
			Score,
			Overlay,
			ExplanationPopup,
		},

		data(){
			return{
				baseUrl : url,
				score: 0,
				answers: [],
				loggedAnswers: [],
				correctAnswers: [],
				question: true,
				time: 0,
				displayTime: 0,
				timeCounter: 0,
				timeInterval: .1,
				intervalEvent: -1,
				timerActive: false,
				explanationPopupActive: false,
				additionalHTML:"",
			}
		},

		beforeMount(){
			this.clear();
			this.buildInfoAddonHTML();
		},

		mounted(){
			this.showTransitorScore(true);
			this.time = +this.questionData.time;
			this.timeCounter = this.time;

			this.timerActive = false;
			
		},

		computed: {

			questionCount(){
				return this.roundData.questions.questions.length;
			},

			backgroundImage: function() {
		        return 'url('+ this.baseUrl + this.roundData.questions.question_background + ')';
		    },

			...mapGetters([
				"lastQuestion",
				"currentBlock",
				"currentStage",
				"currentRound",
				"currentQuestion",
				"roundCount",
				"stageData",
				"roundCompleted",
				"scores",
				"questionData",
				"stageCount",
				"roundScore",
				"roundData",
			]),
		},


		methods:{

			buildInfoAddonHTML(){
				this.additionalHTML = this.roundData.questions.rules;	
			},

			hideExplanationPopup(){
				this.explanationPopupActive = false;
				$('.btn--transition').removeClass('idle');
			},

			showExplanationPopup(){
				this.explanationPopupActive = true;
				$('.btn--transition').addClass('idle');
			},

			startTimer(){
				if(this.intervalEvent != -1) window.clearInterval(this.intervalEvent);
				this.timeCounter = this.time;


				this.intervalEvent = window.setInterval(() => {
					this.timeCounter -= this.timeInterval;

					this.displayTime = parseInt(this.timeCounter,10);

					if(this.timeCounter <= 0){
						this.time = 0;
						this.timeCounter = 0;
						this.displayTime = 0;
						this.stopTimer();
						this.completeQuestion();
					}
				},this.timeInterval*1000);
			},

			stopTimer(){
				window.clearInterval(this.intervalEvent);
				this.intervalEvent = -1;
			},


			...mapActions([
				"completeRound",
				"toNextQuestion",
				"addRoundScore",
				"setRoundScore",
				'hideNextButton',
				'showNextButton',
				'setNextButtonAction',
				"increaseTransitorScore",
				"showTransitorScore",
				"logAnswers",
			]),

			hideOverlay(){
				this.question = false;
				if(this.answers.length > 0){
					this.showNextButton();
				}

				if(this.time > 0 && !this.timerActive){
					this.timerActive = true;
					this.startTimer();
				}
			},

			showOverlay(){
				if(this.answers.length > 0)
				{
					this.hideNextButton().then(() =>
					{
						setTimeout(() =>
						{
							this.question = true;
						}, 500);
					});
				}
				else{
					this.question = true;
				}

			},

			onAnswer(index){

				let arrIndex = this.answers.indexOf(index);
				if(arrIndex >= 0){
					this.answers.splice(arrIndex,1);

					if(this.answers.length == 0){
						this.hideNextButton();
					}
				}
				else{
					this.answers.push(index);
					this.setNextButtonAction(this.completeQuestion).then(()=>{
						this.showNextButton();
					});
				}
			},

			completeQuestion(){
				this.stopTimer();

				this.loggedAnswers.push(this.answers);

				//check answers with correct answers
				this.correctAnswers = this.questionData.correct_answers.split(",");

				console.log(this.correctAnswers);
				console.log(this.answers);

				//loop over all correct answers and check if we have them in the answers
				let correctSelections = 0;
				for (let i = this.correctAnswers.length - 1; i >= 0; i--) {
					
					console.log('check:');
					console.log(Number(this.correctAnswers[i])-1);

					let isInArray = this.answers.indexOf(Number(this.correctAnswers[i])-1);


					console.log('isInArray: '+isInArray);

					if(isInArray != -1){
						correctSelections++;
					}

					
				};

				if(correctSelections > 0){
					this.increaseTransitorScore(correctSelections * 10);
				}

				console.log('result:');

				console.log('correctSelections: '+correctSelections);
				console.log('correctAnswers: '+this.correctAnswers.length);
				console.log('answers: '+this.answers.length);



				if(correctSelections == this.correctAnswers.length && this.answers.length == this.correctAnswers.length){
					console.log('YEAH');
					this.score++;
				}

				

				if(this.lastQuestion){
					this.finishRound();
				}
				else{
					this.clear();

					this.toNextQuestion();

					this.time = +this.questionData.time;
					this.timeCounter = this.time;

					this.timerActive = false;
					
				}
				
			},

			finishRound(){
				this.stopTimer();

				console.log('Simon Says finished');
				console.log(this.loggedAnswers);

				this.setRoundScore((this.score / this.questionCount)*100).then(()=>{
					this.logAnswers(this.loggedAnswers).then(()=>
					{
						this.completeRound();
					});
				});
			},
			

			clear(){
				this.stopTimer();
				this.question = true;
				this.answers = [];
				this.correctAnswers = [];
			},

		}

	}
</script>



// WEBPACK FOOTER //
// src/components/minigames/simonsays/Index.vue